import CattleEventsLayer from './cattle-events.layer';

export default CattleEventsLayer;
